import { IProductType, IProductTypeCreateDto, IProductTypeUpdateDto } from "@lib";
import { Modal } from "@core/components/alt-ui/modal";
import { Button, Control, Panel, TextBox } from "@core/components/alt-ui/controls";

export class ProductTypesModal extends Modal<IProductType> {
    private tbSequence!: TextBox;
    private tbName!: TextBox;
    private tbDescription!: TextBox;

    private pnlFooter!: Panel;
    private btnCancel!: Button;
    private btnSave!: Button;

    private productType: IProductType | null = null;
    public onCreate: ((dto: IProductTypeCreateDto) => Promise<IProductType | null>) | null = null;
    public onUpdate: ((productType: IProductType, dto: IProductTypeUpdateDto) => Promise<IProductType | null>) | null =
        null;

    public constructor() {
        super("product-types-modal", "");
        this.initializeControls();
    }

    public show(productType?: IProductType): Promise<void> {
        this.productType = productType ?? null;
        this.title = productType ? "Изменение типа" : "Новый тип";
        this.initializeControls();

        if (productType) {
            this.populateControls(productType);
        }

        return super.show();
    }

    protected initializeControls(): void {
        this.tbSequence = new TextBox();
        this.tbName = new TextBox();
        this.tbDescription = new TextBox();

        this.pnlFooter = new Panel();
        this.btnCancel = new Button();
        this.btnSave = new Button();

        //

        this.tbSequence.id = "productType.sequence";
        this.tbSequence.label = "Порядок";
        this.tbSequence.validation = "required|numeric|min_value:1|max_value:999";
        this.tbSequence.visible = false;

        this.tbName.id = "productType.name";
        this.tbName.label = "Название";
        this.tbName.validation = "required";

        this.tbDescription.id = "productType.description";
        this.tbDescription.label = "Описание";

        //

        this.btnCancel.id = "productType.cancel";
        this.btnCancel.text = "Отменить";
        this.btnCancel.class = "mr-0.75";
        this.btnCancel.variant = "outline-danger";
        this.btnCancel.addClickHandler(this.clickCancel.bind(this));

        this.btnSave.id = "productType.save";
        this.btnSave.text = "Сохранить";
        this.btnSave.addClickHandler(this.clickSave.bind(this));

        this.pnlFooter.class = "flex justify-end mt-2";
        this.pnlFooter.addControl(this.btnCancel);
        this.pnlFooter.addControl(this.btnSave);
    }

    private populateControls(productType: IProductType): void {
        this.tbSequence.text = productType.sequence.toString();
        this.tbSequence.visible = true;

        this.tbName.text = productType.name;

        this.tbDescription.text = productType.description ?? "";
    }

    public get controls(): Control[] {
        return [this.tbSequence, this.tbName, this.tbDescription, this.pnlFooter];
    }

    private async clickCancel(sender: any, e: any): Promise<void> {
        this.hide();
    }

    private async clickSave(sender: any, e: any): Promise<void> {
        const valid = await this.validate();

        if (!valid) {
            return;
        }

        const result = this.productType ? await this.update(this.productType) : await this.create();

        if (result) {
            this.hide(result);
        }
    }

    private async create(): Promise<IProductType | null> {
        if (!this.onCreate) {
            return null;
        }

        const dto: IProductTypeCreateDto = {
            name: this.tbName.text,
            description: this.tbDescription.text,
        };

        return await this.onCreate(dto);
    }

    private async update(productType: IProductType): Promise<IProductType | null> {
        if (!this.onUpdate) {
            return null;
        }

        const dto: IProductTypeUpdateDto = {
            sequence: parseInt(this.tbSequence.text),
            name: this.tbName.text,
            description: this.tbDescription.text,
        };

        return await this.onUpdate(productType, dto);
    }
}
